import { Controller } from 'stimulus';

class HeaderQuotationController extends Controller {
  openHeaderQuotation() {
    if (this.quotationTarget.classList.contains('is-open')) return;

    this.quotationTarget.classList.add('is-open');
  }

  updateHeaderQuotation(html) {
    $(this.quotationTarget).html(html);

    this.openHeaderQuotation();
  }
}

HeaderQuotationController.targets = [
  'quotation',
  'count',
];

export default HeaderQuotationController;
